export const inquiries =[
    
    {
     "address1" : "5452 N.E. 22nd St.",
     "address_city" : "Des Moines",
     "inquiryTotal": 22,
     "inqDate": 1531342800000,
     "animals_id" : "51586296",
     "animals_name" : "Frank",
     "breeds" : "American Foxhound",
     "gender" : "Male",
     "post" : "50313",
     "state" : "IA",
     "status" : "adoptable"
   },
    {
     "address1" : "1060 Al Bishop Drive",
     "address_city" : "Marietta",
     "inquiryTotal": 24,
     "inqDate": 1531342800000,
     "animals_id" : "51585648",
     "animals_name" : "KNOX",
     "breeds" : "Labrador Retriever",  
     "gender" : "Male",
     "post" : "30008",
     "state" : "GA",
     "status" : "adoptable"
   },
   {
     "address1" : "",
     "address_city" : "Denver",
     "inquiryTotal": 67,
     "inqDate": 1531342800000,
     "animals_id" : "51586252",
     "animals_name" : "Prince",
     "breeds" : "Siberian Husky",
     "gender" : "Male",
     "post" : "80216",
     "state" : "CO",
     "status" : "adoptable"
   },
   {
     "address1" : "884 Winder Hwy (Rte 29)",
     "address_city" : "Lawrenceville",
     "inquiryTotal": 5,
     "inqDate": 1531342800000,
     "animals_id" : "51586294",
     "animals_name" : "Pen Sd 05 Peace;",
     "breeds" : "Shepherd",
     "gender" : "Female",
     "organ_animal_id" : "80085",
     "post" : "30045",
     "state" : "GA",
     "status" : "adoptable"
   },
   {
     "address1" : "884 Winder Hwy (Rte 29)",
     "address_city" : "Lawrenceville",
     "inquiryTotal": 20,
     "inqDate": 1531342800000,
     "animals_id" : "51586295",
     "animals_name" : "S D 13",
     "gender" : "Male",
     "post" : "30045",
     "state" : "GA",
     "status" : "adoptable"
   },
   {
     "address1" : "",
     "address_city" : "Orland Park",
     "inquiryTotal": 14,
     "inqDate": 1531342800000,
     "animals_id" : "51586265",
     "animals_name" : "Lucky",
     "breeds" : "American Bulldog",
     "gender" : "Male",
     "post" : "60462",
     "state" : "IL",
     "status" : "adoptable"
   },
    {
     "address1" : "2913 County Road 220",
     "address_city" : "Middleburg",
     "inquiryTotal": 21,
     "inqDate": 1531342800000,
     "animals_id" : "51586291",
     "animals_name" : "Champ 21291",
     "breeds" : "English Bulldog",
     "gender" : "Male",
     "post" : "32068",
     "state" : "FL",
     "status" : "adoptable"
   },
    {
     "address1" : "",
     "address_city" : "Green Bay",
     "inquiryTotal": 14,
     "inqDate": 1531342800000,
     "animals_id" : "51586270",
     "animals_name" : "Marley",
     "breeds" : "Mixed Breed",
     "country" : "US",
     "gender" : "Male",
     "post" : "54313",
     "state" : "WI",
     "status" : "adoptable"
   },
   {
     "address1" : "",
     "address_city" : "Allen",
     "inquiryTotal": 12,
     "inqDate": 1531342800000,
     "animals_id" : "51586290",
     "animals_name" : "Winston South X412",
     "breeds" : "Boston Terrier",
     "contact_email" : "adopt@dallasdogrrr.org",
     "gender" : "Male",
     "post" : "75013",
     "state" : "TX",
     "status" : "adoptable"
   },
  //   {
  //    "address1" : "",
  //    "address_city" : "Westminster",
  //    "inquiryTotal": 14,
  //    "inqDate": 1531342800000,
  //    "animals_id" : "51586289",
  //    "animals_name" : "Emma",
  //    "breeds" : "Dachshund",
  //    "gender" : "Female",
  //    "post" : "80035",
  //    "state" : "CO",
  //    "status" : "adoptable"
  //  },
  //   {
  //    "address1" : "",
  //    "address_city" : "Shawnee",
  //    "inquiryTotal": 14,
  //    "inqDate": 1531342800000,
  //    "animals_id" : "51586288",
  //    "animals_name" : "Dolce",
  //    "breeds" : "German Shepherd Dog",
  //    "gender" : "Female",
  //    "post" : "66214",
  //    "state" : "KS",
  //    "status" : "adoptable"
  //  },
  //  {
  //    "address1" : "",
  //    "address_city" : "Lynnwood",
  //    "inquiryTotal": 14,
  //    "inqDate": 1531342800000,
  //    "animals_id" : "51586249",
  //    "animals_name" : "PENNY",
  //    "breeds" : "Border Collie",
  //    "gender" : "Female",
  //    "post" : "98037",
  //    "state" : "WA",
  //    "status" : "adoptable"
  //  },
  //   {
  //    "address1" : "",
  //    "address_city" : "Crenshaw",
  //    "inquiryTotal": 21,
  //    "inqDate": 1531342800000,
  //    "animals_id" : "51586286",
  //    "animals_name" : "**MANGO**",
  //    "breeds" : "Yellow Labrador Retriever",
  //    "gender" : "Female",
  //    "post" : "38621",
  //    "state" : "MS",
  //    "status" : "adoptable"
  //  },
  //   {
  //    "address1" : "PO Box 218",
  //    "address_city" : "Rockaway",
  //    "inquiryTotal": 22,
  //    "inqDate": 1531342800000,
  //    "animals_id" : "51586284",
  //    "animals_name" : "Spot Roscoe MOPS",
  //    "breeds" : "Parson Russell Terrier",
  //    "contact_email" : "mainoffice@ehrdogs.org",
  //    "gender" : "Male",
  //    "organ_animal_id" : "5098062-owner surrender",
  //    "post" : "7866",
  //    "state" : "NJ",
  //    "status" : "adoptable"
  //  },
  //  {
  //    "address1" : "",
  //    "address_city" : "Orland Park",
  //    "inquiryTotal": 12,
  //    "inqDate": 1531342800000,
  //    "animals_id" : "51586257",
  //    "animals_name" : "Athena",
  //    "breeds" : "American Bulldog",
  //    "gender" : "Female",
  //    "post" : "60462",
  //    "state" : "IL",
  //    "status" : "adoptable"
  //  },
  //  {
  //    "address1" : "255 Alabama St",
  //    "address_city" : "San Francisco",
  //    "inquiryTotal": 23,
  //    "inqDate": 1531342800000,
  //    "animals_id" : "51586260",
  //    "animals_name" : "Clementine 8907",
  //    "breeds" : "Chihuahua",
  //    "gender" : "Female",
  //    "post" : "94141",
  //    "state" : "CA",
  //    "status" : "adoptable"
  //  },
  //   {
  //    "address1" : "",
  //    "address_city" : "Covina",
  //    "inquiryTotal": 4,
  //    "inqDate": 1531342800000,
  //    "animals_id" : "51586200",
  //    "animals_name" : "Leon",
  //    "breeds" : "Labradoodle",
  //    "gender" : "Male",
  //    "post" : "91723",
  //    "state" : "CA",
  //    "status" : "adoptable"
  //  },
  //   {
  //    "address1" : "",
  //    "address_city" : "Orland Park",
  //    "inquiryTotal": 4,
  //    "inqDate": 1531342800000,
  //    "animals_id" : "51586254",
  //    "animals_name" : "Rhea",
  //    "breeds" : "American Bulldog",
  //    "gender" : "Female",
  //    "post" : "60462",
  //    "state" : "IL",
  //    "status" : "adoptable"
  //  },
  //  {
  //    "address1" : "",
  //    "address_city" : "Las Vegas",
  //    "inquiryTotal": 2,
  //    "inqDate": 1531342800000,
  //    "animals_id" : "51586224",
  //    "animals_name" : "Ebony",
  //    "breeds" : "Labrador Retriever",
  //    "gender" : "Male",
  //    "organ_animal_id" : "C21-000367",
  //    "post" : "89136",
  //    "state" : "NV",
  //    "status" : "adoptable"
  //  },
  //  {
  //    "address1" : "",
  //    "address_city" : "Las Vegas",
  //    "inquiryTotal": 24,
  //    "inqDate": 1531342800000,
  //    "animals_id" : "51586250",
  //    "animals_name" : "Oso",
  //    "breeds" : "Golden Retriever",
  //    "gender" : "Male",
  //    "organ_animal_id" : "C21-000470",
  //    "post" : "89136",
  //    "state" : "NV",
  //    "status" : "adoptable"
  //  }
 ]
 